import React, { useState } from 'react';
import {
    Badge,
    Button,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    MenuList,
    Tooltip,
} from '@mui/material';
import {
    ArrowDropDown,
    Close,
    Done,
} from '@mui/icons-material';
import { red } from '@mui/material/colors';
import { isArrayValidAndNotEmpty } from '../../../utils/nullChecks';
import { KeyValue } from '../../../types/commonTypes';

type Props = {
    selectedValue: string | Array<string> | null, // Key of the option sent
    onSelect: (a: string | Array<string> | null) => void
    multiple?: boolean,
    options: KeyValue[],
    label:string,
    fullWidth?: boolean,
};

const ChipSelectComponent = (props: Props) => {
    const {
        selectedValue,
        onSelect,
        multiple,
        options,
        label,
        fullWidth,
    } = props;

    const anchorRef = React.useRef<HTMLButtonElement>(null);
    const [showOptionMenu, setShowOptionMenu] = useState<boolean>(false);
    const toggle = () => { setShowOptionMenu(!showOptionMenu); };
    const onItemSelect = (option:string) => () => {
        if (multiple) {
            if (isArrayValidAndNotEmpty(selectedValue)) {
                if (selectedValue?.includes(option)) {
                    onSelect([...selectedValue].filter((value) => (option !== value)));
                } else {
                    onSelect([...selectedValue, option]);
                }
            } else {
                onSelect([option]);
            }
        } else {
            onSelect(option);
        }
        toggle();
    };
    const isItemSelected = (item:string) => selectedValue === item || selectedValue?.includes(item);
    const getLabel = () => {
        if (!multiple) {
            return selectedValue || label;
        }
        if (isArrayValidAndNotEmpty(selectedValue)) {
            const display = selectedValue.at(0);
            if (selectedValue.length > 1) {
                const toolTip =
                 selectedValue?.map((item) => <div key={item}>{item}</div>);
                // return `${display}  +${selectedValue!.length - 1}`;
                return (
                    <>
                        {`${display}`}
                        {'\u00A0'}
                        {'\u00A0'}
                        {'\u00A0'}
                        {'\u00A0'}
                        {'\u00A0'}
                        <Tooltip
                            title={toolTip}
                        >
                            <Badge badgeContent={`+${selectedValue.length - 1}`} color="primary" />
                        </Tooltip>
                        {'\u00A0'}
                        {'\u00A0'}

                        {/* {`+${selectedValue!.length - 1}`} */}
                    </>
                );
            }
            return display;
        }

        return label;
    };
    const clearAll = (e:React.MouseEvent<HTMLButtonElement>) => {
        onSelect(null);
        e.stopPropagation();
    };

    return (
        <>
            <Button
                onClick={toggle}
                fullWidth={fullWidth}
                sx={{ justifyContent: 'space-between' }}
                endIcon={(
                    <>
                        {selectedValue && (
                            <IconButton
                                sx={{
                                    padding: 0,
                                    color: red[300],
                                }}
                                onClick={clearAll}
                            >
                                <Close fontSize="small" />
                            </IconButton>
                        )}
                        <ArrowDropDown sx={{ fontSize: 400 }} />
                    </>
                )}
                ref={anchorRef}
            >
                {getLabel()}
            </Button>
            <Menu
                open={showOptionMenu}
                anchorEl={anchorRef.current}
                onClose={toggle}
            >
                <MenuList>
                    {
                        options.map((choice) => (
                            <MenuItem
                                key={choice.key}
                                onClick={onItemSelect(choice.key)}
                                selected={isItemSelected(choice.key)}
                            >
                                <ListItemText>
                                    {choice.value}
                                </ListItemText>
                                <ListItemIcon>
                                    {isItemSelected(choice.key) && (
                                        <Done fontSize="small" />
                                    )}
                                </ListItemIcon>
                            </MenuItem>
                        ))
                    }
                </MenuList>
            </Menu>
        </>
    );
};

ChipSelectComponent.defaultProps = {
    multiple: false,
    fullWidth: false,
};

export default ChipSelectComponent;
